export default {
  dispatchCustomEvent (name, data) {
    const trackingEvent = new CustomEvent(name, { data: data })
    document.dispatchEvent(trackingEvent)
  },

  sendPageview (url) {
    this.dispatchCustomEvent('posabit.page-view', url)
  },

  addProduct (product) {
    this.dispatchCustomEvent('posabit.product.add', product)
  },

  addToCart (product) {
    this.dispatchCustomEvent('posabit.cart.add', product)
  },

  removeFromCart (product) {
    this.dispatchCustomEvent('posabit.cart.remove', product)
  },

  viewProduct (product) {
    this.dispatchCustomEvent('posabit.product.view', product)
  },

  checkout (products) {
    this.dispatchCustomEvent('posabit.checkout', products)
  },

  completeOrder (order, products) {
    this.dispatchCustomEvent('posabit.order.success', {
      order: order,
      products: products
    })
  }
}
